import { render, staticRenderFns } from "./DialogWrapper.vue?vue&type=template&id=35d15dd5&scoped=true&"
import script from "./DialogWrapper.vue?vue&type=script&lang=js&"
export * from "./DialogWrapper.vue?vue&type=script&lang=js&"
import style0 from "./DialogWrapper.vue?vue&type=style&index=0&id=35d15dd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d15dd5",
  null
  
)

export default component.exports